"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_i18next_1 = require("react-i18next");
var react_i18next_2 = require("react-i18next");
var useBackWarning_1 = __importDefault(require("../../hook/useBackWarning"));
var PaymentSuccess_module_scss_1 = __importDefault(require("./PaymentSuccess.module.scss"));
var PaymentSuccess = function () {
    var t = (0, react_i18next_2.useTranslation)().t;
    (0, useBackWarning_1.default)(t("BACK_WARNING_PAYMENT_RESULT"));
    return ((0, jsx_runtime_1.jsx)("main", { className: PaymentSuccess_module_scss_1.default.successPage, children: (0, jsx_runtime_1.jsxs)("section", { className: PaymentSuccess_module_scss_1.default.successCard, children: [(0, jsx_runtime_1.jsx)("h1", { className: PaymentSuccess_module_scss_1.default.successTitle, children: t("PAYMENT_SUCCESS_TITLE") }), (0, jsx_runtime_1.jsx)("p", { className: PaymentSuccess_module_scss_1.default.successText, children: t("PAYMENT_SUCCESS_TEXT") })] }) }));
};
exports.default = (0, react_i18next_1.withTranslation)()(PaymentSuccess);
